import { VehicleHistoryOrderByColumn } from './VehiclesHistory.enums';

export const VehicleHistoryOrderByColumnLabel: Record<
  VehicleHistoryOrderByColumn,
  string
> = {
  [VehicleHistoryOrderByColumn.WorkOrder]: 'Orçamento',
  [VehicleHistoryOrderByColumn.EntryDate]: 'Data de entrada',
};
